export const MAX_LOGIN_ATTEMPTS = 3
export const LOGIN_RETRY_BASE_DELAY_MS = 1000
export const LOGIN_RETRY_MAX_DELAY_MS = 10000

const assertValidAttempt = (attempt: number): void => {
    if (!Number.isFinite(attempt) || !Number.isInteger(attempt) || attempt < 0) {
        throw new RangeError(`Login attempt must be a non-negative integer; received ${attempt}`)
    }
}

export const shouldRetryLogin = (attempt: number): boolean => {
    assertValidAttempt(attempt)
    return attempt + 1 < MAX_LOGIN_ATTEMPTS
}

export const getLoginRetryDelay = (attempt: number): number => {
    assertValidAttempt(attempt)
    return Math.min(LOGIN_RETRY_BASE_DELAY_MS * 2 ** attempt, LOGIN_RETRY_MAX_DELAY_MS)
}
